import { HexColorInput, HexColorPicker } from 'react-colorful';
import styles from './FJColorPickerPanel.module.less';
import FJEyedropper from '../FJEyedropper/FJEyedropper';
import FJConstant from '../../../constants/FJConstant';
import { useState } from 'react';

const FJColorPickerPanel = props => {
    const { activeColor, onChange } = props;
    const [eventType, setEventType] = useState(FJConstant.CHANGE_START);

    const _handleChange = (newColor, eventType = FJConstant.CHANGE_END) => {
        onChange(newColor, eventType);
    };

    return (
        <div className={styles.color_picker_box}>
            <HexColorPicker
                color={activeColor}
                onChange={newColor => {
                    _handleChange(newColor, eventType);
                }}
                onMouseDown={e => setEventType(FJConstant.CHANGE_START)}
                onMouseMove={e => setEventType(FJConstant.CHANGE)}
                onMouseUp={e => {
                    setEventType(FJConstant.CHANGE_END);
                    _handleChange(activeColor, FJConstant.CHANGE_END);
                }}
            />
            <div className={styles.color_input_box}>
                <div className={styles.color_input}>
                    <HexColorInput
                        prefixed={true}
                        color={activeColor}
                        onChange={newColor => _handleChange(newColor, eventType)}
                        onFocus={e => setEventType(FJConstant.CHANGE_START)}
                        onBlur={e => {
                            setEventType(FJConstant.CHANGE_END);
                            _handleChange(activeColor, FJConstant.CHANGE_END);
                        }}
                    />
                </div>
                <FJEyedropper className={styles.eyedropper} callback={_handleChange} />
            </div>
        </div>
    );
};

export default FJColorPickerPanel;
